module.exports = __webpack_public_path__ + "static/img/Home66@2x.b1c8770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home66@2x.png
// module id = 6cQ/
// module chunks = 1